import EncryptDecryptService from 'components/common/services/EncryptDecryptService';
import { createTransform } from 'redux-persist';

// TO-38127 (f_fesec_d4e29ffeed): retire the client-side AES obfuscation of the
// persisted store. The AES key ships in the JS bundle, so "encrypting" localStorage
// with it was obfuscation only (any XSS that reads the store also reads the key).
// We now persist plaintext. The rehydrate path stays backward-compatible so a
// persist:root written by a previous (encrypting) build still loads — then gets
// rewritten as plaintext on the next save.
const rehydrate = (outboundState: any) => {
  if (outboundState && typeof outboundState === 'object') {
    return outboundState; // new: already a plain object
  }
  try {
    return JSON.parse(outboundState); // new: plaintext JSON string
  } catch {
    return JSON.parse(EncryptDecryptService.decryptData(outboundState)); // legacy ciphertext
  }
};

const encryptTransform = createTransform(
  // Store plaintext (redux-persist serializes it normally).
  (inboundState) => inboundState,
  // Rehydrate plaintext, with a fallback for a legacy encrypted persist:root.
  (outboundState) => rehydrate(outboundState),
  { whitelist: ['auth', 'navigation'] }
);

export default encryptTransform;